import "../../assets/css/results/details.css"

import { Row, Col } from "react-bootstrap"

import arrowDown from "../../assets/images/arrowDown.svg"
import CityCard from "./cityCard.jsx"
import { useGeneralStates } from "../../context/general-context"
import { useEffect, useMemo, useState } from "react"
import { useAuth } from "../../context/auth-context"
import { addCommas, CONNECTIVITY_TRAVEL, GOVERNMENT_LANDSCAPE, AIRPORTS, POLITICS, DETAILS_TOTAL_TITLE } from "./utils.js"

export default function Details() {
    const { state, showSubscribeModal, triggerDetailsSection } = useGeneralStates()
    const { user } = useAuth()
    const [actualValue, setActualValue] = useState({
        catPosition: 1,
        varPosition: 1,
        varTitle: "Total payroll cost",
        scores: []
    })

    const catRefPosition = useMemo(() => {
        return state?.wantsMatrixReference.find(catRef => catRef.variables.some(varRef => varRef._id === state?.triggerVariableDetails))?.position
    }, [state])
    
    const variable = useMemo(() => {
        return state?.wantsMatrixReference.find(catRef => catRef.variables.some(varRef => varRef._id === state?.triggerVariableDetails))
                ?.variables.find(varRef => varRef._id === state?.triggerVariableDetails)
    }, [state])

    const scores = useMemo(() => {
        return user?.result.find(varResult => varResult.varRefId === state?.triggerVariableDetails)?.citiesResults
    }, [state, user])
    
    useEffect(() => {
        catRefPosition && variable && setActualValue({
            catPosition: catRefPosition,
            varPosition: variable?.position,
            varTitle: variable?.title,
            scores: scores
        })
    }, [state])

    const detailsSectionClass = `detailsSection ${state.triggerVariableDetails ? "move" : ""}`
    const cardContainerClass = user.selectedCities.length === 2 ? "twoCards" : user.selectedCities.length === 1 ? "oneCard" : ""

    const isConnectivityTravel = useMemo(() => {
        return variable?._id.toString() === CONNECTIVITY_TRAVEL
    }, [variable])

    const isGovernmentLandscape = useMemo(() => {
        return variable?._id.toString() === GOVERNMENT_LANDSCAPE
    }, [variable])

    const isAnyCityCostNull = useMemo(() => {
        return user?.selectedCities.some(city => {
            const cityCost = actualValue.scores.find(actualScore => actualScore.datamexico_municipality_id === city.datamexico_municipality_id)?.cost

            return cityCost === null
        })
    }, [actualValue, user])
    
    return (
        <section className={detailsSectionClass}>
            <Row>
                <Col lg={{ span: 10, offset: 1 }}>
                    <div className="variableDetailsSection">
                        <div className="detailsNavActionsContainer">
                            <div className="variableTitleContainer">
                                <img onClick={() => triggerDetailsSection()} src={arrowDown} alt="Prodensa Teaser" />
                                <span id="detailsVarTitle">{`${actualValue?.catPosition}.${actualValue?.varPosition} ${actualValue?.varTitle}`}</span>
                            </div>
                            <div className="actionsContainer">
                                <button 
                                    id="compareDetails" 
                                    className="btnBgBlueTextGradient"
                                    onClick={showSubscribeModal}
                                >
                                    Compare cities
                                </button>
                                <button
                                    id="criteriaDetails" 
                                    className="btnBgBlueTextGradient"
                                    onClick={showSubscribeModal}
                                >
                                    Criteria
                                </button>
                                <button
                                    id="commentsDetails" 
                                    className="btnBgBlueTextGradient"
                                    onClick={showSubscribeModal}
                                >
                                    Comments
                                </button>
                            </div>
                        </div>

                        <div className={`citiesCardsContainer ${cardContainerClass}`}>
                            {user?.selectedCities.map(city => {
                                const cityResults = actualValue.scores.find(actualScore => actualScore.datamexico_municipality_id === city.datamexico_municipality_id)
                                
                                return (
                                    <CityCard 
                                        key={`cityCard-${city.datamexico_municipality_id}`} 
                                        city={city} 
                                        cityResults={cityResults}
                                        variable={variable}
                                    />
                                )
                            })}
                        </div>

                        <div className="detailsTableSection">
                            <button 
                                id="compareDetails" 
                                className="btnBgBlueTextGradient"
                                onClick={showSubscribeModal}
                            >
                                Compare cities
                            </button>

                            <div className="comparativeTable">
                                <h5 className="tableTitle">Comparison table</h5>

                                <div className="citiesDataContainer">
                                    <div className="tableHeader">
                                        <h5>Concept</h5>

                                        {user?.selectedCities.map(city => {
                                            return (
                                                <h5 key={`city-headerRow-${city.datamexico_municipality_id}`} className="cityValue">
                                                    {city.municipality_name}
                                                </h5>
                                            )
                                        })}
                                    </div>

                                    {!isConnectivityTravel && !isGovernmentLandscape && 
                                        <div className="tableRow">
                                            <h5>{DETAILS_TOTAL_TITLE?.[variable?._id?.toString()]}</h5>
                                            
                                            {user?.selectedCities.map(city => {
                                                // const cityAnnualCost = actualValue.scores.find(actualScore => actualScore.datamexico_municipality_id === city.datamexico_municipality_id)?.cost
                                                // const dataToShow = cityAnnualCost !== null ? addCommas(cityAnnualCost) : "N/A"
                                                const dataToShow = "N/A"

                                                return (
                                                    <h5 key={`total-headerRow-${city.datamexico_municipality_id}`} className="cityValue teaserDataHide">
                                                        {dataToShow}
                                                    </h5>
                                                )
                                            })}
                                        </div>
                                    }

                                    {!isConnectivityTravel && !isGovernmentLandscape && 
                                        <div className="tableRow">
                                            <h5>Difference from better value</h5>
                                            
                                            {user?.selectedCities.map(city => {
                                                const cityScore = actualValue.scores.find(actualScore => actualScore.datamexico_municipality_id === city.datamexico_municipality_id)

                                                const cityAnnualCost = cityScore?.cost
                                                const differenceValue = cityAnnualCost !== null && (!isAnyCityCostNull || (isAnyCityCostNull && user?.selectedCities.length === 3)) ? addCommas(cityScore?.difference) : "N/A"
                                                const typeOfDifference = cityScore?.typeOfDifference
                                                // const textIcon = typeOfDifference === "Percentage" ? "%" : ""
                                                const textIcon = cityAnnualCost !== null && typeOfDifference !== "Special" ? "%" : ""

                                                const textToShow = cityScore?.difference === 0 && cityAnnualCost !== null && (!isAnyCityCostNull || (isAnyCityCostNull && user?.selectedCities.length === 3)) ? 
                                                                    "Best value" : `${differenceValue}${textIcon}`

                                                return (
                                                    <h5 key={`difference-headerRow-${city.datamexico_municipality_id}`} className="cityValue">
                                                        {textToShow}
                                                    </h5>
                                                )
                                            })}
                                        </div>
                                    }

                                    {isConnectivityTravel && 
                                        <div className="tableRow">
                                            <h5>Airport</h5>
                                            
                                            {user?.selectedCities.map(city => {
                                                const cityId = city.datamexico_municipality_id
                                                const dataToShow = AIRPORTS[cityId]
                                                
                                                return (
                                                    <h5 key={`airport-headerRow-${city.datamexico_municipality_id}`} className="cityValue">
                                                        {dataToShow}
                                                    </h5>
                                                )
                                            })}
                                        </div>
                                    }

                                    {isGovernmentLandscape && 
                                        <div className="tableRow">
                                            <h5>State Elections</h5>
                                            
                                            {user?.selectedCities.map(city => {
                                                const cityId = city.datamexico_municipality_id
                                                const dataToShow = POLITICS[cityId].stateElections
                                                
                                                return (
                                                    <h5 key={`stateElections-headerRow-${city.datamexico_municipality_id}`} className="cityValue">
                                                        {dataToShow}
                                                    </h5>
                                                )
                                            })}
                                        </div>
                                    }

                                    {isGovernmentLandscape && 
                                        <div className="tableRow">
                                            <h5>Party in Power</h5>
                                            
                                            {user?.selectedCities.map(city => {
                                                const cityId = city.datamexico_municipality_id
                                                const dataToShow = POLITICS[cityId].partyInPower
                                                
                                                return (
                                                    <h5 key={`party-headerRow-${city.datamexico_municipality_id}`} className="cityValue">
                                                        {dataToShow}
                                                    </h5>
                                                )
                                            })}
                                        </div>
                                    }

                                    {isGovernmentLandscape && 
                                        <div className="tableRow">
                                            <h5>Federal Government in Party</h5>
                                            
                                            {user?.selectedCities.map(city => {
                                                const cityId = city.datamexico_municipality_id
                                                const dataToShow = POLITICS[cityId].federalGovernment
                                                
                                                return (
                                                    <h5 key={`federal-headerRow-${city.datamexico_municipality_id}`} className="cityValue">
                                                        {dataToShow}
                                                    </h5>
                                                )
                                            })}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </section>
    )
}
